export const DAYS = 'last7days';
export const WEEK = 'lastWeek';
export const MONTH = 'lastMonth';
export const SEMESTER = 'lastSemester';
export const YEAR = 'lastYear';
export const AEC = 'aec';
export const MAX = 'max';
